import { MARKETS } from '$lib/services/trustArc/constants';

/* Market to Jurisdiction mapping on BE.
export const MGA_MARKETS: string[] = [
    MARKETS.EN,
    MARKETS.IE,
    MARKETS.FI, // Currently GRA but we are planning to migrate it to MGA.
    MARKETS.ROW,
    MARKETS.ROG
];
export const GRA_MARKETS: string[] = [
    MARKETS.ENCA,
    MARKETS.ENIN,
    MARKETS.JP,
    MARKETS.NO,
    MARKETS.ENNZ
];
export const AGCO_MARKETS: string[] = [MARKETS.ON];
export const UKGC_MARKETS: string[] = [MARKETS.ENGB];
export const DGOJ_MARKETS: string[] = [MARKETS.ES];
export const SGA_MARKETS: string[] = [MARKETS.SV];
*/

export const CASUMO_REGISTRATION_ENABLED_MARKETS = Object.freeze([
    MARKETS.SV,
    MARKETS.IE,
    MARKETS.FI,
    MARKETS.NO,
    MARKETS.ENCA,
    MARKETS.ENNZ,
    MARKETS.EN,
    MARKETS.ROW,
    MARKETS.ROG,
    MARKETS.ENGB,
    MARKETS.ES
]);
export const CASUMO_TEST_REGISTRATION_ENABLED_MARKETS = Object.freeze([
    MARKETS.EN,
    MARKETS.IE,
    MARKETS.FI,
    MARKETS.ROW,
    MARKETS.ROG,
    MARKETS.ENCA,
    MARKETS.NO,
    MARKETS.ENNZ,
    MARKETS.ENGB,
    MARKETS.ES
]);

export const REGISTRATION_ENABLED_MARKETS = Object.freeze([
    'ie',
    'en',
    'en-gb',
    'en-nz',
    'row',
    'rog',
    'on',
    'en-ca',
    'fi',
    'no',
    'sv',
    'es'
]);

export const TEST_AUTH_ISSUER = 'https://auth.casumotest.com/auth/realms/CASUMO';
export const TEST_AUTHORISATION_URL = 'https://www.casumotest.com/api/authorisation';
export const PROD_HOST = 'www.casumo.com';
export const TEST_HOST = 'www.casumotest.com';

export const COOKIES = Object.freeze({
    IS_NATIVE_COOKIE: 'is_native_cookie',
    NATIVE_EVENTS_COOKIE: 'native_events_cookie',
    FIRST_LOGIN_COOKIE: 'first_login',
    CASUMO_COMMON_COOKIE: 'casumo_common_cookie',
    ERROR_NAME: 'error_name',
    KAZUMO: 'kazumo',
    KAZUMO_KEYCLOAK: 'kazumoKeycloak',
    NATIVE_PLAYER_LOGIN_EVENT: 'native_login_event'
});

export const EXCEPTIONAL_ERRORS = Object.freeze({
    SELF_EXCLUDED: 'SELF_EXCLUDED',
    SELF_EXCLUDED_MARKETING: 'SELF_EXCLUDED_MARKETING',
    SELF_EXCLUDED_MARKETING_CANT_REVOKE: 'SELF_EXCLUDED_MARKETING_CANT_REVOKE',
    SELF_EXCLUSION_BEING_REVOKED: 'SELF_EXCLUSION_BEING_REVOKED',
    SELF_EXCLUSION_BEING_REVOKED_UKGC: 'SELF_EXCLUSION_BEING_REVOKED_UKGC',
    BLOCKED: 'BLOCKED',
    TOO_MANY_WRONG_ATTEMPTS: 'TOO_MANY_WRONG_ATTEMPTS'
});
